import { render } from "./AddBalanceModal.vue?vue&type=template&id=fdf6d464&scoped=true"
import script from "./AddBalanceModal.vue?vue&type=script&lang=js"
export * from "./AddBalanceModal.vue?vue&type=script&lang=js"

import "./AddBalanceModal.vue?vue&type=style&index=0&id=fdf6d464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf6d464"]])

export default __exports__